<template>
    <table class="w-full">
        <tr>
            <td class="font-semibold">{{ event.name }}</td>
            <td class="text-center">{{ seats }}</td>
            <td class="text-right">£{{ (event.formatted_price * seats).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
        </tr>
        <template v-for="addon in selectedAddOns">
            <template v-if="hasOptionSelected(addon)">
                <tr>
                    <td colspan="3" class="font-semibold pt-2">{{ addon.name }}</td>
                </tr>
                <tr v-if="addon.applies_to_group">
                    <td class="text-gray-600">{{ nameOfOption(addon.value) }}</td>
                    <td class="text-center">{{ seats }}</td>
                    <td class="text-right">£{{ (seats * priceForOption(addon.value)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                </tr>

                <template v-else>
                    <tr v-for="option in addon.value"
                        v-if="option.value > 0"
                    >
                        <td class="text-gray-500">{{ nameOfOption(option.option_id) }}</td>
                        <td class="text-center">{{ option.value }}</td>
                        <td class="text-right">£{{ (option.value * priceForOption(option.option_id)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                    </tr>
                </template>
            </template>
        </template>

        <tr>
            <td class="pb-4" colspan="3"></td>
        </tr>

        <tr>
            <td class="font-semibold pt-3 border-t border-gray-200">Total</td>
            <td class="text-right font-semibold pt-3 border-t border-gray-200" colspan="2">£{{ total }}</td>
        </tr>
    </table>
</template>

<script>
	export default {
		props: {
		    event: {
		        type: Object,
                required: true,
            },

            selectedAddOns: {
		        type: Object,
                required: true,
            },

            addOnOptions: {
		        type: Array,
                required: true,
            },

            seats: {
		        type: Number,
                required: true,
            },
        },

        computed: {
		    total() {
		        let eventPrice = this.event.formatted_price * this.seats;

		        let addOnPrice = 0;

		        _.forEach(this.selectedAddOns, addon => {
		            if (addon.applies_to_group) {
		                return addOnPrice += this.seats * this.priceForOption(addon.value)
                    }

                    return _.forEach(addon.value, option => {
		                addOnPrice += option.value * this.priceForOption(option.option_id);
                    });
                });

                return (eventPrice + addOnPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
        },

        methods: {
		    hasOptionSelected(addOn) {
		        if (addOn.applies_to_group) return true;

		        return ! _.isUndefined(_.find(addOn.value, option => {
		            return option.value > 0;
                }));
            },

		    nameOfOption(optionId) {
                return _.find(this.addOnOptions, ['id', optionId]).name;
            },

            priceForOption(optionId) {
                return _.find(this.addOnOptions, ['id', optionId]).price;
            }
        }
	}
</script>
